import type {ReactElement} from 'react';
import {Route, Routes} from 'react-router-dom';
import {useTranslation} from 'react-i18next';

import type ConnectionsModel from '@refinio/one.models/lib/models/ConnectionsModel.js';
import type LeuteModel from '@refinio/one.models/lib/models/Leute/LeuteModel.js';
import type TopicModel from '@refinio/one.models/lib/models/Chat/TopicModel.js';
import {APP_BAR_MODE} from '@refinio/one.ui/lib/ui/components/appBar/AppBar.js';
import type {SHA256Hash, SHA256IdHash} from '@refinio/one.core/lib/util/type-checks.js';

import PageNotFound from '@/components/PageNotFound.js';
import AppBarSettings from '@/components/appBar/AppBarSettings.js';
import {useNavigateBack} from '@/hooks/navigation.js';
import IdentityView from './identity/IdentityView.js';

export default function IdentityRouter(props: {
    leuteModel: LeuteModel;
    topicModel: TopicModel;
    connectionsModel: ConnectionsModel;
    getTrustView?: (hashes: (SHA256Hash | SHA256IdHash)[]) => ReactElement;
}): ReactElement {
    const {connectionsModel, leuteModel, topicModel} = props;
    const i18n = useTranslation();
    const goBack = useNavigateBack();

    return (
        <Routes>
            <Route
                path={'/:someoneId/:identity'}
                element={
                    <>
                        <AppBarSettings
                            mode={APP_BAR_MODE.CHEVRON_VIEW}
                            title={i18n.t('leute.identity.title')}
                            leftBtnCallback={goBack}
                        />
                        <IdentityView
                            topicModel={topicModel}
                            leuteModel={leuteModel}
                            connectionsModel={connectionsModel}
                            getInformationAddon={props.getTrustView}
                        />
                    </>
                }
            />
            <Route element={<PageNotFound />} />
        </Routes>
    );
}
